// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "build/js/" + chunkId + "." + {"594":"9b30236c","959":"aaa810c1"}[chunkId] + ".js";
};